import React from 'react';
import ReactHtmlParser from 'react-html-parser';

const Partner = (props) => (
    <div className="partner">
        <div className="inner-container">
            <div className="content-container">
                <header>
                    <h2 name="friendsfoundation">{props.title}</h2>
                </header>
                <div className="partner__inner-container">
                    {ReactHtmlParser(props.content)}
                </div>
                <a
                    className="cta-btn white"
                    href="mailto:mail@thefriendsfoundation.com">
                    Sign up
                </a>
            </div>
        </div>
    </div>
);
export default Partner;



// WEBPACK FOOTER //
// ./src/components/Pages/About/Partner.jsx